<template lang="pug">
  v-dialog(:value="value" max-width="600" @input="close")
    v-card
      validation-observer(ref="obs" v-slot="{ handleSubmit }")
        v-form(ref="form")
          v-card-title.headline.mb-4.ml-1 {{ dialogTitleText }}
            v-spacer
            v-btn(icon @click="close")
              v-icon mdi-close
          v-card-subtitle.text-subtitle-1 {{ course.title }}
          v-card-text
            validation-provider(
              v-slot="{ errors, valid }"
              rules="required|integer"
              name="Цена курса"
              vid="coursePrice"
            )
              v-text-field(
                v-model="coursePrice"
                :error-messages="errors"
                label="Цена курса"
                rounded
                filled
              )

          v-card-actions
            v-spacer
            v-btn(color="warning" rounded text @click="close") Отмена
            v-btn(
              v-if="!course.price"
              :loading="loading"
              color="success"
              rounded
              text
              @click="handleSubmit(sendToExchange)"
            ) Отправить
            v-btn(
              v-else
              :loading="loading"
              color="success"
              rounded
              text
              @click="handleSubmit(updateCoursePrice)"
            ) Изменить

</template>

<script>
export default {
  name: 'SendToExchangeDialog',
  props: {
    /**
     * @model
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * Выбранный курс для отправки на биржу/изменения цены
     */
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      coursePrice: null,
    };
  },
  computed: {
    dialogTitleText() {
      return this.course.price ? 'Изменить цену курса' : 'Отправить курс на биржу курсов';
    },
  },
  watch: {
    course() {
      this.coursePrice = this.course.price;
    },
  },
  methods: {
    /**
     * Вызывается при отправке нового курса на биржу курсов
     */
    sendToExchange() {
      this.loading = true;
      const courseData = {
        course_id: this.course.id,
        title: this.course.title,
        description: this.course.description,
        price: this.coursePrice,
      };
      this.$rHandler(
        this.$api.exchange.placeCourseOnExchange(courseData),
        () => {
          this.loading = false;
          this.close();
          this.$toasted.success('Курс успешно отправлен на биржу', { duration: 3000 });
        },
        () => {},
        this.$refs.obs,
      );
    },
    /**
     * Вызывается при редактировании цены существующего курса на бирже
     */
    updateCoursePrice() {
      this.loading = true;
      const courseData = {
        price: this.coursePrice,
      };
      this.$rHandler(
        this.$api.exchange.updateOwnSellingCourse(this.course.id, courseData),
        () => {
          this.loading = false;
          this.close();
          this.$toasted.success('Цена успешно изменена', { duration: 3000 });
          this.$emit('price:update');
        },
        () => {},
        this.$refs.obs,
      );
    },
    close() {
      this.$emit('input', false);
      this.$refs.obs.reset();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
